export default class ShowPasswordButton {
  constructor(button, options) {
    this.button = button;
    this.options = {
      activeClass: 'is-active',
      ...options,
    };
    this.isActive = false;
  }

  /**
   * Init
   */
  init() {
    if (this.button.getAttribute('data-target')) {
      this.input = document.querySelector(this.button.getAttribute('data-target'));
      this.button.addEventListener('click', (event) => this.toggle(event));
    }
  }

  /**
   * Toggle
   * @param {event} event click event
   */
  toggle(event) {
    event.preventDefault();

    if (this.isActive) {
      this.hide();
    } else {
      this.show();
    }
  }

  /**
   * Open
   */
  show() {
    this.button.classList.add(this.options.activeClass);
    this.input.type = 'text';
    this.isActive = true;
  }

  /**
   * Close
   */
  hide() {
    this.button.classList.remove(this.options.activeClass);
    this.input.type = 'password';
    this.isActive = false;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const buttons = Array.from(document.querySelectorAll('[data-toggle="show-password-button"]'));
  buttons.forEach((button) => {
    const showPasswordButton = new ShowPasswordButton(button);

    showPasswordButton.init();
  });
});
